// extracted by mini-css-extract-plugin
module.exports = {"buttonpage":"PaginadoStyle_buttonpage__3L54u","buttonactive":"PaginadoStyle_buttonactive__3I3eg"};